module.exports = __webpack_public_path__ + "img/denied.e1afe642.svg";